import { Switch } from "@mui/material";
import { useEffect } from "react";
import { NewRequestMetadataInputProps } from "../new-request-metadata-input";

const NewRequestInputBool = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, onChange } = props;

  const handleOnChange = (checked: boolean) => {
    const _value = checked ? "True" : "False";
    onChange(metadata.values?.find((x) => x.value === _value));
  };

  return (
    <Switch
      checked={value?.value === "True" || false}
      onChange={(e, value) => handleOnChange(value)}
      disabled={!metadata.values?.length || metadata.values?.length <= 1}
    />
  );
};

export default NewRequestInputBool;
